import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Button, Input } from 'reactstrap';
import { Dispatch } from 'redux';
import { Group, Groups, Server, Server2, User, Users, Workspaces } from '../../clients/aasServerClient.generated';
import { deleteGroups } from '../../stores/groups/actionCreators';
import { getGroupName } from '../../stores/groups/selectors';
import { RootState } from '../../stores/store';
import { select, unselect } from '../../stores/tables/actionCreators';
import { isSelected } from '../../stores/tables/selectors';
import { getUserName } from '../../stores/users/selectors';
import { getWorkspaceName } from '../../stores/workspaces/selectors';
import ConfirmModal from '../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps, RouteComponentProps {
    group: Group;
    selected: boolean;
    getUserName: (id: string) => string;
    getWorkspaceName: (id: string) => string;

    select: (id: string) => void;
    unselect: (id: string) => void;
    delete: (id: string) => void;
}

interface State {
    showDelete: boolean;
}

class GroupsTableRow extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            showDelete: false,
        };
    }

    public render() {
        const t = this.props.translate;
        const group = this.props.group;
        return (
            <tr
                className={classnames('table-row', this.props.selected ? 'selected' : '')}
                onClick={(e) => {
                    this.props.selected ?
                        this.props.unselect(group.id) : this.props.select(group.id);
                }}
            >
                <td ><Input type="checkbox" checked={this.props.selected} onChange={() => null} /></td>
                <td>{group.name}</td>
                <td>{this.getUserCell(group.users)}</td>
                <td>{this.getWorkspaceCell(group.workspaces)}</td>
                <td className="icon-btn-td">
                    <Button
                        color="primary"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.props.history.push('/groups/edit/' + this.props.group.id);
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'pencil']} className="noMarginRight" />
                    </Button>
                </td>
                <td className="icon-btn-td">
                    <Button
                        color="danger"
                        onClick={(e) => {
                            e.stopPropagation();
                            this.setState({ showDelete: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'trash']} className="noMarginRight" />
                    </Button>
                    <ConfirmModal
                        header={t('groups.modal.delete.header') as string}
                        confirmText={t('groups.modal.delete.delete') as string}
                        isOpen={this.state.showDelete}
                        buttonColor="danger"
                        cancel={() => this.setState({ showDelete: false })}
                        confirm={() => this.props.delete(this.props.group.id)}
                    >
                        {`${t('groups.modal.delete.text')} ${this.props.group.name || this.props.group.id}`}
                    </ConfirmModal>
                </td>
            </tr>
        );
    }

    private getUserCell = (users?: Users[]) => {
        if (users === undefined || users.length === 0) {
            return '';
        } else if (users.length > 1) {
            return this.props.translate('groups.table.cells.assigned', { number: users.length });
        } else {
            return this.props.getUserName(users[0].id);
        }
    }

    private getWorkspaceCell = (workspaces: Workspaces[] | undefined) => {
        if (workspaces === undefined || workspaces.length === 0) {
            return '';
        } else if (workspaces.length > 1) {
            return this.props.translate('groups.table.cells.assigned', { number: workspaces.length });
        } else {
            return this.props.getWorkspaceName(workspaces[0].id);
        }
    }
}

const mapStateToProps = (state: RootState, props: { group: Group }) => ({
    getUserName: getUserName(state),
    getWorkspaceName: getWorkspaceName(state),
    selected: isSelected(state, 'groups', props.group.id),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    delete: (id: string) => dispatch(deleteGroups([id])),
    select: (id: string) => dispatch(select('groups', id)),
    unselect: (id: string) => dispatch(unselect('groups', id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withLocalize(GroupsTableRow)));